import React, { useState } from "react";
import { connect } from "react-redux";
import styled, { ThemeProvider, withTheme } from "styled-components";
import ScrollToTop from "../../components/library/ScrollToTop/ScrollToTop";
import CustomModal, {
  ModalSize,
} from "../../components/ui-library/CustomModal/CustomModal";
import SmartLogin from "../../components/smart/Login/Login";
import EligibilitySurvey from "../../components/smart/EligibilitySurvey/EligibilitySurvey";
import SmartSignUp from "../../components/smart/SignUp/SignUp";
import SmartAccountConfirmation from "../../components/smart/AccountConfirmation/AccountConfirmation";
import SmartPasswordRecovery from "../../components/smart/PasswordRecovery/PasswordRecovery";
import SmartPasswordDefine from "../../components/smart/PasswordDefine/PasswordDefine";
import SmartAdminRegistration from "../../components/smart/AdminRegistration/AdminRegistration";
import SmartNotice from "../../components/smart/Notice/Notice";
import LoggedOut from "../../components/library/LoggedOut/LoggedOut";
import ToastManager from "../../components/ToastManager/ToastManager";
import { modalType } from "../../modules/constants";
import {
  mapDispatchToPropsLogin,
  mapStateToPropsLogin,
} from "../../modules/login";
import { mapDispatchToPropsRecovery } from "../../modules/recovery";
import { mapStateToPropsTheme } from "../../modules/theme";
import SmartAuditTrailComment from "../../components/smart/AuditTrailComment/AuditTrailComment";
import { currentStudy } from "../../config";
import { useTranslation } from "react-i18next";
import CookieBanner from "../../components/library/CookieBanner/CookieBanner";
import Navigation from "../../components/library/Navigation/Navigation";
import Footer from "../../components/library/Footer/Footer";

const StyledApp = styled.div`
  background-color: ${(props) => props?.theme?.bg};
  color: ${(props) => props?.theme?.fg};
  margin-top: 75px;

  padding: 30px 20px 0px 20px;

  @media (max-width: 320px) {
    margin-top: 63px;
  }

  @media only screen and (max-width: 768px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    padding: 30px 0px 30px 0px;
  }
`;

const ComponentWithLayout = (props) => {
  const {
    theme,
    authModalProps,
    onAuthModalClose,
    closeModalGoHome,
    closeModalLogout,
    modalSubtitle,
    modalButtonText,
    setOpenAuthModal,
    route,
    resetSubmittedChangeState,
  } = props;

  const [surveyTitle, setSurveyTitle] = useState("");

  const study = currentStudy().toUpperCase();

  const { t } = useTranslation();

  const hideFooter = [
    modalType.adminRegistrationProcess,
    modalType.changePassword,
    modalType.accountConfirmation,
  ];

  const closeModal = () => {
    resetSubmittedChangeState();
    closeModalGoHome();
  };

  const largeCustomModal = {
    ...authModalProps,
    size: ModalSize.large,
    title: surveyTitle,
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastManager />
      <ScrollToTop>
        <Navigation isLogged={props.isLogged} withSidebar={props.withSidebar} />
        <CookieBanner />
        <SmartAuditTrailComment route={route} />
        <StyledApp className="App" theme={theme}>
          {authModalProps?.current === modalType.login && (
            <CustomModal {...authModalProps} onClose={onAuthModalClose}>
              <SmartLogin />
            </CustomModal>
          )}
          {authModalProps?.current === modalType.eligibility && (
            <CustomModal {...largeCustomModal} onClose={onAuthModalClose}>
              <EligibilitySurvey
                setSurveyTitle={setSurveyTitle}
                study={study}
              />
            </CustomModal>
          )}
          {authModalProps?.current === modalType.register && (
            <CustomModal {...authModalProps} onClose={onAuthModalClose}>
              <SmartSignUp />
            </CustomModal>
          )}
          {authModalProps?.current === modalType.recoverPassword && (
            <CustomModal {...authModalProps} onClose={onAuthModalClose}>
              <SmartPasswordRecovery />
            </CustomModal>
          )}
          {authModalProps?.current === modalType.loggedOut && (
            <CustomModal {...authModalProps} onClose={onAuthModalClose}>
              <LoggedOut
                modalSubtitle={modalSubtitle}
                modalButtonText={modalButtonText}
                handleSubmit={() =>
                  setOpenAuthModal(
                    modalType.login,
                    t("contentText.login.title")
                  )
                }
              />
            </CustomModal>
          )}
          {authModalProps?.current === modalType.adminRegistrationProcess && (
            <CustomModal {...authModalProps} onClose={closeModalGoHome}>
              <SmartAdminRegistration showAdminReg={true} />
            </CustomModal>
          )}
          {authModalProps?.current === modalType.changePassword && (
            <CustomModal {...authModalProps} onClose={closeModal}>
              <SmartPasswordDefine showPwRecovery={true} />
            </CustomModal>
          )}
          {authModalProps?.current === modalType.accountConfirmation && (
            <CustomModal {...authModalProps} onClose={closeModalGoHome}>
              <SmartAccountConfirmation showAccountConfirmation={true} />
            </CustomModal>
          )}

          {authModalProps?.current === modalType.notice && (
            <CustomModal {...authModalProps} onClose={closeModalLogout}>
              <SmartNotice />
            </CustomModal>
          )}
          {props.children}
        </StyledApp>
        {!hideFooter.includes(authModalProps?.current) && (
          <Footer withSidebar={props.withSidebar} isLogged={props.isLogged} />
        )}
      </ScrollToTop>
    </ThemeProvider>
  );
};

const ComponentWithTheme = (props) => {
  return (
    <ThemeProvider theme={props.theme}>
      <ToastManager />
      {props.children}
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    ...mapStateToPropsLogin(state),
    ...mapStateToPropsTheme(state),
  };
};

export default {
  ComponentWithLayout: connect(mapStateToProps, {
    ...mapDispatchToPropsLogin,
    ...mapDispatchToPropsRecovery,
  })(withTheme(ComponentWithLayout)),
  ComponentWithTheme: connect(
    mapStateToProps,
    mapDispatchToPropsLogin
  )(withTheme(ComponentWithTheme)),
};
